import { Empty, Skeleton, Spin } from "antd";

export const LoadingCircleImage = ({ data, width, height }) => {
  return (
    <div>
      {!data ? (
        <Skeleton.Avatar
          active
          shape="circle"
          style={{ width: `${width}px`, height: `${height}px` }}
        />
      ) : (
        <img src={data} alt="image" />
      )}
    </div>
  );
};

export const LoadingParagraph = ({ data, component }) => {
  return (
    <div>{!data ? <Skeleton.Input active size="small" /> : component}</div>
  );
};

export const LoadingSpin = ({ data, component, style, size, isLoading }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
      {isLoading ? (
        <Spin size={size ? size : "small"} />
      ) : data.length > 0 ? (
        component
      ) : (
        <Empty />
      )}
    </div>
  );
};

export const LoadingList = ({
  data,
  component,
  rows,
  avatar,
  recordNum = 4,
}) => {
  const listSkeleton = Array.from({
    length: recordNum,
  }).map((_, i) => {
    return (
      <Skeleton
        key={i}
        style={{ marginBottom: "30px" }}
        avatar={avatar}
        paragraph={{
          rows: rows,
        }}
        active
      />
    );
  });
  return (
    <div>{data ? data.length > 0 ? component : <Empty /> : listSkeleton}</div>
  );
};
